import { ApiExerciseActionType, ChatStatus, ChatDisplay } from "@tt-app/models/exercise";

/**
 * Map an exercise action type with chat status
 */
export const CHAT_ACTION_STATUS_MAPPING: { [key in ApiExerciseActionType]: ChatStatus } = {
  SHOW_END_BUTTONS: "Ended",
  SHOW_REVIEW: "Ended",
  SHOW_START_BUTTONS: "IntroWaitForUser",
  SHOW_TROPHY: "ShowTrophy"
};

/**
 * Map an exercise action type with a chat display window
 */
export const CHAT_ACTION_DISPLAY_MAPPING: { [key in ApiExerciseActionType]: ChatDisplay } = {
  SHOW_END_BUTTONS: "chat",
  SHOW_REVIEW: "chat",
  SHOW_START_BUTTONS: "chat",
  SHOW_TROPHY: "trophy"
};
